import { useAuth } from '@/hooks/useAuth';
import { Button } from '@/components/Button';

export function WorkspacePage() {
  const { currentTenant } = useAuth();

  return (
    <div className="p-4">
      {/* Page header */}
      <div className="mb-4">
        <h1 className="text-lg font-semibold text-foreground">Workspace</h1>
        <p className="text-sm text-foreground-muted">Manage your workspace details and settings</p>
      </div>

      {/* Form */}
      <div className="max-w-2xl space-y-6">
        {/* Workspace Name */}
        <div className="rounded border border-border bg-background-subtle p-4">
          <label className="block text-sm font-medium text-foreground mb-2">Workspace Name</label>
          <input
            type="text"
            defaultValue={currentTenant?.tenantName || ''}
            className="w-full rounded border border-border bg-background px-3 py-2 text-sm text-foreground focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary"
            placeholder="My 3D Printing Workshop"
          />
          <p className="mt-2 text-xs text-foreground-muted">This is the name that appears across your workspace</p>
        </div>

        {/* Workspace Logo */}
        <div className="rounded border border-border bg-background-subtle p-4">
          <label className="block text-sm font-medium text-foreground mb-3">Workspace Logo</label>
          <div className="flex items-center gap-4">
            <div className="flex h-16 w-16 items-center justify-center rounded bg-primary/20 text-primary">
              <span className="text-2xl font-bold">
                {currentTenant?.tenantName?.charAt(0).toUpperCase() || 'W'}
              </span>
            </div>
            <Button size="sm" variant="secondary">Upload Logo</Button>
          </div>
        </div>

        {/* Default Printer */}
        <div className="rounded border border-border bg-background-subtle p-4">
          <label className="block text-sm font-medium text-foreground mb-2">Default Printer</label>
          <select className="w-full rounded border border-border bg-background px-3 py-2 text-sm text-foreground focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary">
            <option>None</option>
            <option>Bambu Lab P1S</option>
            <option>Prusa MK4</option>
          </select>
          <p className="mt-2 text-xs text-foreground-muted">Default printer for new print jobs</p>
        </div>

        {/* Time Zone */}
        <div className="rounded border border-border bg-background-subtle p-4">
          <label className="block text-sm font-medium text-foreground mb-2">Time Zone</label>
          <select className="w-full rounded border border-border bg-background px-3 py-2 text-sm text-foreground focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary">
            <option>UTC-8 (Pacific Time)</option>
            <option>UTC-5 (Eastern Time)</option>
            <option>UTC+0 (GMT)</option>
            <option>UTC+1 (Central European Time)</option>
          </select>
        </div>

        {/* Save Button */}
        <div className="flex justify-end gap-2">
          <Button variant="secondary">Cancel</Button>
          <Button variant="primary">Save Changes</Button>
        </div>
      </div>
    </div>
  );
}
